module.exports = __webpack_public_path__ + "static/media/train_32.ba3d65fc.jpg";